import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import OverlayView from 'components/OverlayView';
import useSearchRedirect from 'hooks/store/useSearchRedirect';
import 'styles/components/modals/TimeoutModal';

const propTypes = {
  isExpired: PropTypes.bool.isRequired,
  searchDepartureDate: PropTypes.string.isRequired,
  searchReturnsDate: PropTypes.string.isRequired,
};

const TimeoutModal = ({ isExpired, searchDepartureDate, searchReturnsDate }) => {
  const { features } = useSelector((state) => state.whitelabelConfig);
  const { t } = useTranslation('general');
  const { handleGotoSearch } = useSearchRedirect();

  useEffect(() => {
    if (isExpired) {
      const timer = setTimeout(() => {
        handleGotoSearch({ searchDepartureDate, searchReturnsDate });
      }, 1000 * 10);
      return () => clearTimeout(timer);
    }
  }, [handleGotoSearch, isExpired, searchDepartureDate, searchReturnsDate]);

  if (!features.PURCHASE_TIMER_ENABLED) {
    return null;
  }

  return (
    <OverlayView title="time_out" visible={isExpired} headerButton={false} visibleHeader={false}>
      <div className="timeout-modal">
        <h4>{t('time_is_over')}</h4>
        <i className="timeout-modal-icon" />
        <p className="content">{t('time_out_select_trip_again')}</p>
        <button
          className="button-primary"
          onClick={() => handleGotoSearch({ searchDepartureDate, searchReturnsDate })}
        >
          {t('button.select_new_schedule')}
        </button>
        <p className="footer">{t('text.you_will_be_redirected')}...</p>
      </div>
    </OverlayView>
  );
};

TimeoutModal.propTypes = propTypes;

export default TimeoutModal;
